import { json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { Lead } from '#app/components/typography/lead.tsx'
import { readSource } from '../sections/sections.server.tsx'
import { Description, Features, Source, type componentProps, Usage, Styling } from '../sections/sections.tsx'

export const handle = {
	breadcrumb: 'Lead',
}

const component: componentProps = {
	name: 'Lead',
	shortName: 'Lead',
	fileName: 'lead',
	category: 'typography',
	description: [
		'A lead paragraph is an introductory paragraph that you can use at the top of a page to summarise the content. The lead paragraph should only be used once per page. This is a lead paragraph.',
	],
	features: ['Can be used to summarise the content of a page.', "Opts-in to your design system's typographic styles."],
	parts: [
		{
			name: 'lead',
			description:
				'A lead paragraph is an introductory paragraph that you can use at the top of a page to summarise the content. The lead paragraph should only be used once per page. This is a lead paragraph.',
			props: [],
			state: [],
			events: [],
			layout: [],
			accessibility: [],
		},
	],
	usage: `<Lead>This is a lead paragraph.</Lead>`,
	styling: `.lead {
	@apply text-muted-500 my-fluid-11 text-fluid-xl max-w-prose font-normal leading-relaxed tracking-tight;
}`,
}

export const loader = async () => json({ source: await readSource({ category: component.category, fileName: component.fileName }) })

const TextRoute = () => {
	const { source } = useLoaderData<typeof loader>()
	const { name, description, shortName, fileName, features, usage, styling } = component

	return (
		<>
			<Description name={name} description={description} />
			<Usage usage={usage} shortName={shortName} />
			<Lead>This is a lead paragraph.</Lead>
			<Features features={features} />
			<Source source={source} fileName={fileName} />
			<Styling styling={styling} />
		</>
	)
}
export default TextRoute
